
import React from 'react';
import { Flex } from 'theme-ui';

const rating = ({ rating, total }) => {
  return (
    <>
      <Flex sx={{ gap: '8px', alignItems: 'center' }}>
        <div
          sx={{
            position: 'relative',
            width: '130px',
            height: '26px',
            overflow: 'hidden',
          }}
        >
          <div
            sx={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.7779 3.25651C17.7579 2.22231 16.5456 1.40217 15.2107 0.843291C13.8759 0.284412 12.4449 -0.00217774 11 1.24593e-05C4.94265 1.24593e-05 0.0276444 4.94831 0 11.0611V11.1125C0.000394981 13.9468 1.07161 16.674 2.99477 18.7368C4.91794 20.7996 7.54789 22.0424 10.3473 22.2112C10.525 22.2243 10.6913 22.305 10.8125 22.4371C10.9336 22.5692 11.0007 22.7429 11.0001 22.923V25.5592C11 25.6464 11.0256 25.7316 11.0734 25.8041C11.1213 25.8766 11.1894 25.9331 11.2691 25.9665C11.3488 25.9998 11.4365 26.0085 11.5211 25.9915C11.6056 25.9745 11.6833 25.9325 11.7443 25.8708L12.248 25.3613L18.411 19.3236L18.4234 19.313L18.8804 18.8652C20.8111 16.8575 22 14.1244 22 11.1125V11.061C21.9909 8.01648 20.7597 5.2594 18.7779 3.25651Z' fill='%23CCCCCC'/%3E%3C/svg%3E%0A")`,
              backgroundSize: '26px 26px',
              backgroundRepeatY: 'no-repeat',
              width: '100%',
              height: '26px',
            }}
          />
          <div
            sx={{
              position: 'absolute',
              left: 0,
              top: '50%',
              transform: 'translateY(-50%)',
              backgroundImage: `url("data:image/svg+xml,%3Csvg width='26' height='26' viewBox='0 0 26 26' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M18.7779 3.25651C17.7579 2.22231 16.5456 1.40217 15.2107 0.843291C13.8759 0.284412 12.4449 -0.00217774 11 1.24593e-05C4.94265 1.24593e-05 0.0276444 4.94831 0 11.0611V11.1125C0.000394981 13.9468 1.07161 16.674 2.99477 18.7368C4.91794 20.7996 7.54789 22.0424 10.3473 22.2112C10.525 22.2243 10.6913 22.305 10.8125 22.4371C10.9336 22.5692 11.0007 22.7429 11.0001 22.923V25.5592C11 25.6464 11.0256 25.7316 11.0734 25.8041C11.1213 25.8766 11.1894 25.9331 11.2691 25.9665C11.3488 25.9998 11.4365 26.0085 11.5211 25.9915C11.6056 25.9745 11.6833 25.9325 11.7443 25.8708L12.248 25.3613L18.411 19.3236L18.4234 19.313L18.8804 18.8652C20.8111 16.8575 22 14.1244 22 11.1125V11.061C21.9909 8.01648 20.7597 5.2594 18.7779 3.25651Z' fill='%235388FF'/%3E%3C/svg%3E%0A")`,
              backgroundSize: '26px 26px',
              backgroundRepeatY: 'no-repeat',
              width: rating,
              height: '26px',
            }}
          />
        </div>
        {total && <div sx={{ fontSize: 4, color: 'primary' }}>({total})</div>}
      </Flex>
    </>
  );
};

export default rating;
